export default __webpack_public_path__ + "assets/0020c336a6332f33ab3f93836952d166.png";